function getBgImage(className) {
    let element = document.querySelectorAll(className);
    Array.prototype.forEach.call(element, function(item) {
        if (item) {
            let value = item.getAttribute("data-bg");
            item.style.background = "url('" + value + "') no-repeat center center";
            item.style.backgroundSize = "cover";
        }
    });
}

function init() {
    getBgImage("[data-bg]");
}

export default { init };
